import { render, staticRenderFns } from "./DeleteResolutionBlock.vue?vue&type=template&id=0be9fe90&"
import script from "./DeleteResolutionBlock.vue?vue&type=script&lang=js&"
export * from "./DeleteResolutionBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports